import React from "react";
import {
  MLSectionWrapper,
  MLContainer,
  MLCard,
} from "./LibraryToolStyled";

const mlTools = [
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771555539/scikitlearn_f83l1p.png",
    title: "Scikit-Learn",
    desc: "Classical machine learning algorithms and model utilities",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
    title: "TensorFlow",
    desc: "Deep learning framework for neural networks",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771555859/pythorchpng_knrdug.png",
    title: "PyTorch",
    desc: "Flexible research-focused deep learning framework",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771474101/numpy-logo-png_seeklogo-398690-249068227_bv2bx6.png",
    title: "NumPy",
    desc: "Numerical computing library for scientific operations",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771475072/pandas_maps53.png",
    title: "Pandas",
    desc: "Data preprocessing and analysis tools",
  },
  {
    src: "https://res.cloudinary.com/dywqyzge2/image/upload/v1771475510/opencv_logo_icon_170887-3310837203_dl9dmk.png",
    title: "OpenCV",
    desc: "Open-source library for computer vision, image processing, and video analysis",
  },
];

export default function MLSection() {
  return (
    <MLSectionWrapper>
      <MLContainer>
        {mlTools.map((tool, idx) => (
          <MLCard key={idx}>
            <img src={tool.src} alt={tool.title} loading="lazy" />
            <h5>{tool.title}</h5>
            {/*<p>{tool.desc}</p> */}
          </MLCard>
        ))}
      </MLContainer>
    </MLSectionWrapper>
  );
}
